import { LocalizedString } from '@synergy/models';
import { ReactNode } from 'react';

import { LocalizedContext } from './localized-provider';

interface LocalizedFunctionResult {
    localization: string;
}

interface LocalizedProps {
    value?: LocalizedString;
    children?: (data: LocalizedFunctionResult) => ReactNode;
}

export const Localized = (props: LocalizedProps) => {
    return (
        <LocalizedContext.Consumer>
            {context => {
                const localization = context.getLocalizedString(props.value);
                return props.children && typeof props.children === 'function'
                    ? props.children({ localization })
                    : localization;
            }}
        </LocalizedContext.Consumer>
    );
};
